import { useAuth } from '@/lib/auth';
import { Badge } from '@/components/ui/primitives';

export interface EligibilityFacts {
  verifiedAt?: string | null;
  eligibilityAt?: string | null;
  eligibilityOutcome?: string | null;
  externalEligibilityDate?: string | null;
}

export type ChipState = { label: string; variant: 'success' | 'warning' | 'destructive' };

function sameDay(value: string | null | undefined, now: Date): boolean {
  if (!value) return false;
  const at = new Date(value.length === 10 ? `${value}T00:00:00` : value);
  return at.getFullYear() === now.getFullYear() && at.getMonth() === now.getMonth() && at.getDate() === now.getDate();
}

export function eligibilityChipState(facts: EligibilityFacts, nphies: boolean, now = new Date()): ChipState {
  if (nphies) {
    if (facts.eligibilityOutcome === 'not_eligible' && sameDay(facts.eligibilityAt, now)) return { label: 'Not eligible', variant: 'destructive' };
    if ((facts.eligibilityOutcome === 'eligible' && sameDay(facts.eligibilityAt, now)) || sameDay(facts.externalEligibilityDate, now)) return { label: 'Checked today', variant: 'success' };
    return { label: 'Not checked', variant: 'warning' };
  }
  if (sameDay(facts.verifiedAt, now) || sameDay(facts.externalEligibilityDate, now)) return { label: 'Verified today', variant: 'success' };
  return { label: 'Not verified', variant: 'warning' };
}

export function EligibilityChip({ coverage }: { coverage: EligibilityFacts }) {
  const { hasModule } = useAuth();
  const state = eligibilityChipState(coverage, hasModule('nphies'));
  return <Badge variant={state.variant}>{state.label}</Badge>;
}
